import axios from "axios";
import CookieInstance from "../../../utils/cookie";
import * as localStorage from "../../../utils/localStorage";

const getAuthHeaders = () => {
  const token = CookieInstance.getCookie(
    process.env.REACT_APP_COOKIE_NAME || "userToken"
  );
  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
};

export const getProducts = () => {
  const baseURL =
    process.env.REACT_APP_PURCHASE_API_URL || "https://example.com/api/v1/";
  return axios.get(`${baseURL}products`, getAuthHeaders());
};

export const createOrder = (productName) => {
  const baseURL =
    process.env.REACT_APP_PURCHASE_API_URL || "https://example.com/api/v1/";
  const { id: userId } = localStorage.getItem("profile");
  return axios.post(`${baseURL}orders`, { userId, productName }, getAuthHeaders());
};

export const captureOrder = (orderId) => {
  const baseURL =
    process.env.REACT_APP_PURCHASE_API_URL || "https://example.com/api/v1/";
  return axios.post(`${baseURL}orders/capture`, { orderId }, getAuthHeaders());
};
